import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import {registerCustomValidators} from './validators';

import {App} from './components';

registerCustomValidators();

ReactDOM.render(<App />, document.getElementById('root'));
